import { dataView } from '../../../../constants';
export const useStyles = {
  navigation: { height: '20px' },
  separator: {
    fontSize: 12,
    fontWeight: 400,
    margin: '0px 10px',
    color: theme => theme.color.separator,
  },
  connectSeparator: {
    color: theme => theme.color.darkGrey3,
    margin: '0px 6px',
  },
  criticalWrapper: {
    color: theme => theme.color.criticalRed,
  },
  padLeft: {
    paddingLeft: '4px',
  },
  connectWrapper: {
    fontSize: 11,
    lineHeight: '20.7px',
  },
  title: {
    fontSize: '14px',
    fontWeight: '700',
    color: theme => theme.palette.primary.main,
    lineHeight: 1,
    marginBottom: '4px',
  },
  titleAndDesc: {
    width: '90%',
  },
  percentage: {
    display: 'flex',
    alignItems: 'center',
    fontSize: 14,
    fontWeight: 700,
    lineHeight: '25.3px',
  },
  navContent: {
    fontSize: 10,
    color: theme => theme.palette.primary.main,
    lineHeight: 2,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    cursor: 'pointer',
  },
  sitesLoading: {
    cursor: 'not-allowed',
    opacity: 0.5,
  },
  hr: {
    margin: '5px 0px',
    borderColor: theme => theme.color.originalBlack,
    opacity: 0.1,
  },
  link: { textDecoration: 'none' },
  equipOptions: {
    fontSize: 10,
  },
  autoTxt: {
    width: '300px',
    position: 'absolute',
    left: '8px',
    top: '8px',
    zIndex: '1000',
    background: theme => theme.color.white,
    '& .MuiAutocomplete-inputRoot': {
      height: '30px',
      paddingTop: '8px',
      fontSize: '10px',
      paddingRight: '30px !important',
    },
  },
  subHeadRoot: {
    fontSize: '12px',
    color: theme => theme.color.originalBlack,
    lineHeight: '30px',
    borderBottom: theme => `1px solid ${theme.color.darkGrey3}`,
    margin: '0px 8px',
    padding: '0px',
  },
  switchContent: {
    fontSize: '12px',
    color: theme => theme.color.originalBlack,
    fontWeight: 500,
  },
  summaryClose: {
    background: 'none',
    border: 'none',
    position: 'absolute',
    top: '2px',
    right: '4px',
    cursor: 'pointer',
  },
  titleDiv: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  combocodeDesc: {
    fontWeight: 500,
    fontSize: '12px',
    display: 'flex',
    padding: '8px 0px',
    width: '90%',
    lineHeight: 'normal',
  },
};

export const navOptions = [
  {
    id: 1,
    label: 'Site_summary',
    imgName: 'summary',
    view: dataView?.siteSummary,
  },
  {
    id: 2,
    label: 'To-do_list',
    imgName: 'todo',
    view: dataView?.todoList,
  },
  {
    id: 3,
    label: 'Live_connect',
    imgName: 'live',
    view: dataView?.liveConnect,
  },
];

export const mapConstant = {
  all: 'ALL',
  gap: 'GAP',
  insight: 'INSIGHT',
  gapStatus: ['GOOD', 'PLAN'],
};

export const sitesOptions = [
  {
    id: 1,
    label: 'Critical',
    value: 'CRITICAL',
  },
  {
    id: 2,
    label: 'Urgent',
    value: 'URGENT',
  },
  {
    id: 3,
    label: 'All',
    value: mapConstant?.all,
  },
];

export const statusOptions = {
  [mapConstant.all]: {
    dn: 'All',
    id: mapConstant?.all,
  },
  [mapConstant.gap]: {
    dn: 'Good_and_Plan',
    id: mapConstant?.gap,
  },
};

export const allSitesOptions = [
  {
    id: 1,
    label: 'All',
    value: mapConstant?.all,
  },
  {
    id: 2,
    label: 'By_Insight_status',
    value: mapConstant?.insight,
  },
  {
    id: 3,
    label: 'Good_and_Plan',
    value: mapConstant?.gap,
  },
];

export const defaultValue = {
  type: '',
  percentage: '',
};

export const workOrderOptions = [
  {
    id: 1,
    label: 'None_of_the_units_have_work_orders',
    value: 'none',
    mobileSupportedValue: 'none',
  },
  {
    id: 2,
    label: 'Some_units_without_work_order',
    value: 'some',
    mobileSupportedValue: 'some_without_wo',
  },
  {
    id: 3,
    label: 'Completed_without_improvement',
    value: 'complete',
    mobileSupportedValue: 'comp_without_imp',
  },
  {
    id: 4,
    label: 'In_progress',
    value: 'inprogress',
    mobileSupportedValue: 'in_progress',
  },
];

export const includeWorkOrderFilter = {
  label: 'Filter_with_work_orders',
  name: 'isWorkOrderFilter',
};

export const autoObj = {
  country: 'Country',
  state: 'State',
  city: 'City',
  sites: 'Sites',
};

export const valueFilterOptions = [
  { code: 'equals', label: 'Equal_to', mobileSupportedValue: 'equal' },
  {
    code: 'nonequals',
    label: 'Not_Equal_to',
    mobileSupportedValue: 'not_equal',
  },
  { code: 'lessthan', label: 'Less_than', mobileSupportedValue: 'less_than' },
  {
    code: 'lessthanorequals',
    label: 'Less_than_or_Equal_to',
    mobileSupportedValue: 'less_than_or_equal',
  },
  {
    code: 'greaterthan',
    label: 'Greater_than',
    mobileSupportedValue: 'greater_than',
  },
  {
    code: 'greaterthanorequals',
    label: 'Greater_than_or_Equal_to',
    mobileSupportedValue: 'greater_than_or_equal',
  },
];

export const workOrderTypes = [
  {
    key: 'woInp',
    translations: {
      CRITICAL: 'Critical_and_workorder_in_progress',
      URGENT: 'Urgent_and_workorder_in_progress',
      PLAN: 'Plan_and_workorder_in_progress',
      UAP: 'UAP_and_workorder_in_progress',
    },
  },
  {
    key: 'woCmp',
    translations: {
      CRITICAL: 'Critical_and_workorder_completed',
      URGENT: 'Urgent_and_workorder_completed',
      PLAN: 'Plan_and_workorder_completed',
      UAP: 'UAP_and_workorder_completed',
    },
  },
  {
    key: 'woNp',
    translations: {
      CRITICAL: 'Critical_and_no_workorder',
      URGENT: 'Urgent_and_no_workorder',
      PLAN: 'Plan_and_no_workorder',
      UAP: 'UAP_and_no_workorder',
    },
  },
];
export const splitter = '&$#';

export const preValue = {
  GOOD: {
    type: 'greaterthanorequals',
    percentage: 90,
  },
  URGENT: {
    type: 'greaterthanorequals',
    percentage: 30,
  },
  CRITICAL: {
    type: 'greaterthanorequals',
    percentage: 30,
  },
  PLAN: {
    type: 'greaterthanorequals',
    percentage: 90,
  },
  'NOT-CONN': {
    type: 'greaterthanorequals',
    percentage: 0,
  },
  NODATA: {
    type: 'greaterthanorequals',
    percentage: 10,
  },
  GAP: {
    type: 'greaterthanorequals',
    percentage: 90,
  },
};
